import * as Cesium from "cesium";
import LightWallMaterialProperty from "./material/LightWallMaterialProperty";
import { CENTER } from "./effectConfig";

/**
 * 光墙：环绕指定中心
 * options: lng, lat, color(tint), halfSize, wallHeight, materialName
 */
export default class LightWall {
  constructor(viewer, options = {}) {
    this.viewer = viewer;
    const ground = options.groundHeight ?? 1110;
    const wallH = options.wallHeight ?? 280;
    const half = options.halfSize ?? 0.006;
    const tint =
      options.color ?? Cesium.Color.fromCssColorString("#ea80fc");
    const matName = options.materialName ?? `LightWallMaterial_${Date.now()}`;

    this.LightWallMaterial = new LightWallMaterialProperty(matName, tint);

    const lng = options.lng ?? CENTER.lng;
    const lat = options.lat ?? CENTER.lat;
    const top = ground + wallH;

    const corners = [
      lng - half,
      lat - half,
      top,
      lng + half,
      lat - half,
      top,
      lng + half,
      lat + half,
      top,
      lng - half,
      lat + half,
      top,
      lng - half,
      lat - half,
      top,
    ];

    const minH = [ground, ground, ground, ground, ground];

    this.entity = viewer.entities.add({
      name: options.name ?? "lightWall",
      position: Cesium.Cartesian3.fromDegrees(lng, lat, top + 40),
      wall: {
        positions: Cesium.Cartesian3.fromDegreesArrayHeights(corners),
        minimumHeights: minH,
        material: this.LightWallMaterial,
      },
    });
  }

  setVisible(show) {
    this.entity.show = show;
  }
}
